/**
 * Gets a theme by theme name from Registry
 * @param themeName
 * @param themeRegistry
 * @returns {*|null}
 */
const getThemeFromRegistry = (themeName, themeRegistry) => {
  return themeName && themeRegistry && themeRegistry[themeName] ? themeRegistry[themeName] : null;
};
export default getThemeFromRegistry;